<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column w-85pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'manage_employee_step3_desc' | translate }}</h2>
                <ul>   
                    <li (click)="setMarketingVideoUrl(1)">
                        <a class="videoLink1" (click)="IsvideoActive(1);">
                            <span class="watch-video-text"> {{ 'label_watch_video' | translate }} </span>
                            <img class="mt-0" src="assets/svg-icons/new-video-icon.svg" alt="" class="watch-video-img">
                        </a>
                    </li>                                
                </ul>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning mr-2"
                (click)="fnShowConfigureshowLoggingAlertPanel()" [ngClass]="{'disabled-state': infoToaster }">
                    {{ "log" | translate }}
                </button>
                <button type="button" class="btn eod-btn-primary mr-2"
                [ngClass]="{'disabled': disableSave || infoToaster }" (click)="saveApprovalRules()">
                    {{ "label_save" | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnBacktoWizard()">
                    {{ 'back_to_wizard' | translate }}
                </button>
            </div>
        </header>
        <div class="block mt-2 heightCalc-5 overflow-auto">
            <!-- <h5 class="fw-600 border-bottom w-100pc padding-bottom-10">{{ 'select_approval_rule' | translate }}</h5> -->
            <div class="row">
                <div class="col-md-12 no-padding-right-left pb-3 border-bottom">
                    <input type="radio" class="align-middle svg-20 cursor-pointer position-relative" style="top: -2px" 
                    [checked]="approvalRuleSetting == 1"(change)="onApprovalRuleChange(1)">
                    <span class="fw-700 eod-text-warning-02 f-18">{{ 'label_manual_assignment' | translate }} 
                        <img src="assets/images/crown.svg" alt="new" class="newImgWizard" style="width: 20px;">
                    </span>
                    <p class="d-block padding-left-30 pt-1 f-16">
                        {{ 'manual_approval_description' | translate }}
                    </p>
                </div> 
                <div class="col-md-12 no-padding-right-left pb-3 mt-3">
                    <input type="radio" class="align-middle svg-20 cursor-pointer" style="top: -2px"
                        [checked]="autoApprovalRules.indexOf(approvalRuleSetting) > -1" (change)="onApprovalRuleChange(2)">
                    <span class="fw-700 eod-text-warning-02 f-18">{{ 'label_auto_assignment' | translate }}<span class="eod-text-success fw-700 pl-2">({{ 'paid_function' | translate }})</span></span>
                    <p class="d-block padding-left-30 mt-2  f-16">{{ 'auto_approval_description' | translate }}</p>
                    <p class="d-flex justify-content-start align-items-center margin-left-30 pt-2 f-14">
                        <i class="fas fa-exclamation-circle color-red pr-2"></i>
                        <span class="fw-700 eod-text-danger">
                            {{ 'cost_centre_mandatory' | translate }}
                        </span>
                    </p>
                </div>
                <div class="col-lg-12 px-4 ml-1 mt-3 mb-4">
                    <input type="radio" class="align-middle svg-20 cursor-pointer position-absolute" [checked]="approvalRuleSetting == 2"
                            (change)="onApprovalRuleChange(2)">
                    <p class="d-block margin-left-30 f-16 text-justify">
                        <span class="fw-700 eod-text-primary mr-1">{{ 'auto_approval_rule_a' | translate }}:</span>
                        <span>{{ 'auto_approval_description_a' | translate }}</span>
                    </p>
                </div>
                <div class="col-lg-12 pl-4 ml-1 pr-4 mb-4">
                    <input type="radio" class="align-middle svg-20 cursor-pointer position-absolute" [checked]="approvalRuleSetting == 3"
                        (change)="onApprovalRuleChange(3)">
                    <p class="d-block margin-left-30 f-16 text-justify">
                        <span class="fw-700 eod-text-primary mr-1">{{ 'auto_approval_rule_b' | translate }}:</span>
                        <span>{{ 'auto_approval_description_b' | translate }}</span>
                    </p>
                </div>
                <div class="col-lg-12 pl-4 ml-1 pr-4 mb-4">
                    <input type="radio" class="align-middle svg-20 cursor-pointer position-absolute" [checked]="approvalRuleSetting == 4"
                        (change)="onApprovalRuleChange(4)">
                    <p class="d-block margin-left-30 f-16 text-justify">
                        <span class="fw-700 eod-text-primary mr-1">{{ 'auto_approval_rule_c' | translate }}:</span>
                        <span>{{ 'auto_approval_description_c' | translate }}</span>
                    </p>
                </div>
                <div class="col-lg-12 pl-4 ml-1 pr-4 mb-4">
                    <input type="radio" class="align-middle svg-20 cursor-pointer position-absolute" [checked]="approvalRuleSetting == 5"
                        (change)="onApprovalRuleChange(5)">
                    <p class="d-block margin-left-30 f-16 text-justify">
                        <span class="fw-700 eod-text-primary mr-1">{{ 'auto_approval_rule_d' | translate }}:</span>
                        <span>{{ 'auto_approval_description_d' | translate }}</span>
                    </p>
                </div>
                <div class="col-lg-12 pl-4 ml-1 pr-4 mb-4">
                    <input type="radio" class="align-middle svg-20 cursor-pointer position-absolute" [checked]="approvalRuleSetting == 6"
                        (change)="onApprovalRuleChange(6)">
                    <p class="d-block margin-left-30 f-16 text-justify">
                        <span class="fw-700 eod-text-primary mr-1">{{ 'auto_approval_rule_e' | translate }}:</span>
                        <span>{{ 'auto_approval_description_e' | translate }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<marketing-popup *ngIf="showCostCentreMarketingPopup" [data]="costCentreMarketingPopupModel"
    (closePanel)="onMarketingPopupClosed()">
</marketing-popup>

<div class="overLayDiv" [ngClass]="{ 'active': showAlertPanel }"></div>
<div id="rightSideBar" [hidden]="!showAlertPanel">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'label_alert' | translate }}</h2>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2 padding-top-0">
                <ul class="manageEmp--Notes">
                    <li class="border-bottom list-style-none margin-bottom-5 padding-top-5">
                        <p class="color-black lH-normal" [innerHTML]="claimantErrorLabel"></p>
                    </li>
                    <li class="margin-bottom-5 padding-top-5">
                        <p class="color-black lH-normal padding-bottom-10">
                            {{ 'claimants_without_cost_centre_2' | translate }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click)="closeAlertPanel()">
                {{ 'cancel' | translate }}
            </button>
            <button type="button" class="btn eod-btn-primary" (click)="goToCostCentrePage()">
                {{ 'assign_cc_to_claimants' | translate }}
            </button>
        </footer>
    </div>
</div>

<app-video-icon [VideoUrl]="marketingVideoUrl | safeUrl" [isIconHide]="true">
</app-video-icon>
